// extracted by css-extract-rspack-plugin
export default {"root":"src-components-NodeStatus-NodeStatusIcon-module__root-SYcft4","online":"src-components-NodeStatus-NodeStatusIcon-module__online-euOrZc","warning":"src-components-NodeStatus-NodeStatusIcon-module__warning-k6H6KE","alert":"src-components-NodeStatus-NodeStatusIcon-module__alert-PXoSNW","offline":"src-components-NodeStatus-NodeStatusIcon-module__offline-BdZBNu","loading":"src-components-NodeStatus-NodeStatusIcon-module__loading-eZAech","spin":"src-components-NodeStatus-NodeStatusIcon-module__spin-c9ajbd"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-NodeStatus-NodeStatusIcon-module__root-SYcft4\",\"online\":\"src-components-NodeStatus-NodeStatusIcon-module__online-euOrZc\",\"warning\":\"src-components-NodeStatus-NodeStatusIcon-module__warning-k6H6KE\",\"alert\":\"src-components-NodeStatus-NodeStatusIcon-module__alert-PXoSNW\",\"offline\":\"src-components-NodeStatus-NodeStatusIcon-module__offline-BdZBNu\",\"loading\":\"src-components-NodeStatus-NodeStatusIcon-module__loading-eZAech\",\"spin\":\"src-components-NodeStatus-NodeStatusIcon-module__spin-c9ajbd\"}";
        // 1790730173221
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  